import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { usePlatformAuthStore } from '@/stores/platform-auth.store';
import { PLATFORM_ROUTES } from '@/routes/platform-routes';

export function PlatformProtectedRoute() {
  const isAuthenticated = usePlatformAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`${PLATFORM_ROUTES.LOGIN}?redirect=${redirect}`} replace />;
  }

  return <Outlet />;
}
